import { createContext, useState, useCallback } from 'react'
import ToastContainer from '../components/ToastContainer'

export const ToastContext = createContext(null)

/**
 * Toast Context Provider
 * Manages toast state and provides toast methods to the entire app
 */
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback((type, message, duration = 4000) => {
    const id = Date.now() + Math.random()
    const newToast = { id, type, message, duration }

    setToasts((prev) => [...prev, newToast])

    return id
  }, [])

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id))
  }, [])

  const success = useCallback((message, duration) => {
    return addToast('success', message, duration)
  }, [addToast])

  const error = useCallback((message, duration) => {
    return addToast('error', message, duration)
  }, [addToast])

  const warning = useCallback((message, duration) => {
    return addToast('warning', message, duration)
  }, [addToast])

  const info = useCallback((message, duration) => {
    return addToast('info', message, duration)
  }, [addToast])

  const value = {
    success,
    error,
    warning,
    info,
    removeToast
  }

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer toasts={toasts} onRemoveToast={removeToast} />
    </ToastContext.Provider>
  )
}
